export default function ServiceAIBlock() {
  return (
    <section className="py-20 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-[#70DC28]/10 border border-[#70DC28]/30 px-4 py-1.5 rounded-full mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-robot-line text-[#70DC28] text-sm"></i>
            </div>
            <span className="text-[#58C016] text-xs font-bold tracking-widest uppercase">Quick Reference</span>
          </div>
          <h2 className="font-bebas text-4xl lg:text-5xl text-[#0f0f0f] leading-tight mb-8">
            WHAT IS LOCAL MOVING AND<br />
            <span className="text-[#70DC28]">HOW DOES IT WORK?</span>
          </h2>
          <div className="bg-white rounded-lg border border-neutral-200 p-8 space-y-5">
            <div>
              <h3 className="font-bebas text-xl text-[#0f0f0f] mb-2">What is local moving?</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Local moving refers to any residential or commercial relocation within the same city or metropolitan area — typically under 50 miles. Beast Mode Movers specializes in local moves throughout Melbourne, FL and all of Brevard County.
              </p>
            </div>
            <div className="h-px bg-neutral-100" />
            <div>
              <h3 className="font-bebas text-xl text-[#0f0f0f] mb-2">How is local moving priced?</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Most local moves are billed hourly. Your quote includes the moving truck, labor, and all moving equipment. We provide a clear estimate upfront so there are no surprises on move day.
              </p>
            </div>
            <div className="h-px bg-neutral-100" />
            <div>
              <h3 className="font-bebas text-xl text-[#0f0f0f] mb-2">Who should hire a local mover?</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Anyone moving within Brevard County — whether a studio apartment, family home, or office space. Hiring a professional local moving company protects your belongings and saves significant time and effort versus DIY moves.
              </p>
            </div>
            <div className="h-px bg-neutral-100" />
            <div>
              <h3 className="font-bebas text-xl text-[#0f0f0f] mb-2">Service area</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                <strong>Primary coverage:</strong> Melbourne, FL · Titusville, FL · Rockledge, FL · Palm Bay, FL · Cocoa Beach, FL · Merritt Island, FL · Satellite Beach, FL · Viera, FL
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
